import { useEffect, useState } from "react";
import { useAuthentication } from "../../hooks/useAuthentication";
import { useUserAPI } from "../../contexts/UserAPIContext";
import { useNavigate } from "react-router-dom";
import LogoInn from "../../assets/logo_inn.png";

const Login = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [resetEmail, setResetEmail] = useState("");
    const [resetSuccess, setResetSuccess] = useState(false);
    const [showResetModal, setShowResetModal] = useState(false);
    const [isLoggingIn, setIsLoggingIn] = useState(false);

    const { login, resetPassword, error: authError, loading } = useAuthentication();
    const { fetchUserData, clearUserData } = useUserAPI();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setIsLoggingIn(true);

        try {
            const user = {
                email,
                password,
            };

            console.log('🔑 Iniciando processo de login...');
            
            // 1. Fazer login no Firebase
            const userCredential = await login(user);
            console.log('✅ Login Firebase realizado com sucesso');

            // 2. Buscar dados do usuário via endpoint /me
            console.log('📡 Buscando dados do usuário via /me...');
            const userData = await fetchUserData(true); // forceRefresh = true
            
            console.log('✅ Dados do usuário obtidos:', userData);
            console.log('🎯 Redirecionando para dashboard...');
            
            // 3. Redirecionar baseado no role do usuário
            if (userData.userRoleId === 5) {
                console.log('🔄 Usuário com role 5, redirecionando para Exportações...');
                navigate('/Exportacoes');
            } else if (userData.userRoleId === 6) {
                console.log('📅 Usuário com role 6, redirecionando para Calendário...');
                navigate('/Calendario');
            } else {
                console.log('🏠 Usuário com role padrão, redirecionando para Home...');
                navigate('/');
            }
            
        } catch (error) {
            console.error('❌ Erro durante o login:', error);
            
            if (error.message.includes('Token inválido') || error.message.includes('401')) {
                setError('Usuário não encontrado ou não autorizado no sistema.');
            } else if (error.message.includes('Usuário ou senha incorretos')) {
                setError('Email ou senha incorretos.');
            } else {
                setError('Erro ao fazer login. Tente novamente.');
            }
            
            // Limpar dados em caso de erro
            clearUserData();
        } finally {
            setIsLoggingIn(false);
        }
    };

    const handleResetPassword = async (e) => {
        e.preventDefault();
        setError("");
        setResetSuccess(false);

        const success = await resetPassword(resetEmail);
        if (success) {
            setResetSuccess(true);
            setResetEmail("");
            setTimeout(() => {
                setShowResetModal(false);
                setResetSuccess(false);
            }, 3000);
        }
    };

    useEffect(() => {
        if (authError) {
            setError(authError);
        }
    }, [authError]);

    return (
        <div className="vh-100 d-flex align-items-stretch bg-light">
            <div className="card border-0 rounded-0 w-100 shadow-none">
                <div className="card-body d-flex flex-column justify-content-center p-3 p-sm-4">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-12 col-sm-8 col-md-6 col-lg-5 col-xl-4">
                                <div className="text-center mb-4">
                                    <img 
                                        src={LogoInn} 
                                        alt="Logo Inn" 
                                        className="img-fluid" 
                                        style={{ width: "160px" }} 
                                    />
                                </div>
                                <div className="login form content">
                                    {error && (
                                        <div className="alert alert-danger py-2" role="alert">
                                            {error}
                                        </div>
                                    )}
                                    <form onSubmit={handleSubmit}>
                                        <div className="form-group">
                                            <h4 className="text-center fw-bold mb-4">Insira os dados de Login</h4>
                                            <div className="mb-3">
                                                <label className="form-label">Email</label>
                                                <input 
                                                    type="email" 
                                                    name="email" 
                                                    id="email" 
                                                    className="form-control form-control-lg" 
                                                    value={email} 
                                                    required
                                                    onChange={(e) => setEmail(e.target.value)} 
                                                    placeholder="Digite seu email"
                                                />
                                            </div>
                                            <div className="mb-4">
                                                <label className="form-label">Senha</label>
                                                <input 
                                                    type="password" 
                                                    name="password" 
                                                    id="password" 
                                                    className="form-control form-control-lg" 
                                                    value={password} 
                                                    required
                                                    onChange={(e) => setPassword(e.target.value)} 
                                                    placeholder="Digite sua senha"
                                                />
                                            </div>
                                            <div className="d-grid gap-2">
                                                {!(loading || isLoggingIn) && (
                                                    <button className="btn btn-primary btn-lg">
                                                        Entrar
                                                    </button>
                                                )}
                                                {(loading || isLoggingIn) && (
                                                    <button className="btn btn-primary btn-lg" disabled>
                                                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                        {isLoggingIn ? 'Verificando usuário...' : 'Aguarde...'}
                                                    </button>
                                                )}
                                                <button 
                                                    type="button" 
                                                    className="btn btn-link text-decoration-none"
                                                    onClick={() => setShowResetModal(true)}
                                                >
                                                    Esqueci minha senha
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Modal de Reset de Senha */}
            {showResetModal && (
                <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header border-bottom-0">
                                <h5 className="modal-title fw-bold">Recuperar Senha</h5>
                                <button 
                                    type="button" 
                                    className="btn-close"
                                    onClick={() => {
                                        setShowResetModal(false);
                                        setResetEmail("");
                                        setResetSuccess(false);
                                    }}
                                ></button>
                            </div>
                            <div className="modal-body px-4 py-4">
                                {resetSuccess ? (
                                    <div className="alert alert-success mb-0">
                                        Email de recuperação enviado com sucesso! Verifique sua caixa de entrada.
                                    </div>
                                ) : (
                                    <form onSubmit={handleResetPassword}>
                                        <div className="mb-3">
                                            <label className="form-label">Digite seu email</label>
                                            <input 
                                                type="email" 
                                                className="form-control form-control-lg" 
                                                value={resetEmail} 
                                                onChange={(e) => setResetEmail(e.target.value)}
                                                required 
                                                placeholder="Seu email de cadastro"
                                            />
                                        </div>
                                        <div className="d-flex justify-content-end gap-2">
                                            <button 
                                                type="button" 
                                                className="btn btn-secondary" 
                                                onClick={() => {
                                                    setShowResetModal(false);
                                                    setResetEmail("");
                                                    setResetSuccess(false);
                                                }}
                                            >
                                                Voltar
                                            </button>
                                            <button 
                                                type="submit" 
                                                className="btn btn-primary"
                                                disabled={loading}
                                            >
                                                {loading ? (
                                                    <>
                                                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                        Enviando...
                                                    </>
                                                ) : "Enviar"}
                                            </button>
                                        </div>
                                    </form>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default Login